import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { ContextMenuButton } from 'shared/mui/ContextMenu';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';

export type ContextMenuLinksButtonProps = {
  onClick: VoidFunction;
};

export const ContextMenuLinksButton: React.FC<ContextMenuLinksButtonProps> = ({ onClick }) => {
  const { onCloseMenu } = useContextMenuContext();
  const translate = useTypedTranslate();

  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={<InsertLinkIcon color="secondary" />}
      label={translate('app.orderAdjustmentsReport.searchLinks')}
      onClick={handleClick}
    />
  );
};
